"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
// @ts-ignore-next-line importsNotUsedAsValues
require("react");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const StateButton = ({ text, className, onClick = () => { }, href }) => {
    const buttonClassNames = (0, classnames_1.default)('btn btn-primary', 'margin-top-10', className && className);
    // In case a href is given, render a link button instead
    if (href) {
        return ((0, jsx_runtime_1.jsx)("a", Object.assign({ className: buttonClassNames, href: href, onClick: onClick }, { children: text })));
    }
    return ((0, jsx_runtime_1.jsx)("button", Object.assign({ className: buttonClassNames, type: 'button', onClick: onClick }, { children: text })));
};
exports.default = StateButton;
